import { useTranslation } from 'react-i18next';

const PopupComment = ({ isOpen, onClose, children }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="popup-exam-file popup-comment">
      <div className="popup-overlay" onClick={onClose}></div>
      <div className="popup-content">
        <div className="popup-header">
          <button className="btn btn-icon" onClick={onClose}>
            <span className="icon icon-plus"></span>
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default PopupComment;
